module.exports = __webpack_public_path__ + "e78d56643813aeb6734185d8d84153b8.pdf";